var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ageing-template',{attrs:{"wrinkles":_vm.wrinkles,"wrinkles-ai-selected":_vm.wrinklesAiSelected,"drying-skin":_vm.dryingSkin,"drying-skin-visible":_vm.isDryingQuestionsVisible,"dry-open-pores":_vm.dryOpenPores,"dry-open-pores-visible":_vm.isDryingQuestionsVisible,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }